import React from 'react';
import Chapter from './Chapter';
import { filterPublicChapters } from '../utils/patreonUtils';

function ChapterList({ chapters }) {
  // Only show publicly available chapters (hide patreon-exclusive ones)
  const publicChapters = filterPublicChapters(chapters);
  
  return (
    <div className="chapter-list">
      {publicChapters.map(chapter => (
        <Chapter key={chapter.id} chapter={chapter} />
      ))}
    </div>
  );
}

export default ChapterList;